import { Link, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Logo } from "./Logo";
import { useAuth, homeFor } from "../context/AuthContext";

const LINKS = [
  { label: "Services", href: "/#services", tid: "nav-services-link" },
  { label: "How It Works", href: "/#how-it-works", tid: "nav-how-it-works-link" },
  { label: "AI Verification", href: "/#ai-verification", tid: "nav-ai-verification-link" },
  { label: "For Business", href: "/#business", tid: "nav-business-link" },
  { label: "Contact", href: "/#contact", tid: "nav-contact-link" },
];

export default function PublicNav({ onGetService }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="glass-nav" data-testid="public-nav">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-home-link"><Logo /></Link>
        <nav className="hidden items-center gap-1 md:flex">
          {LINKS.map((l) => (
            <a key={l.label} href={l.href} data-testid={l.tid}
              className="rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100">{l.label}</a>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2">
          {user ? (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-dashboard-button" onClick={() => navigate(homeFor(user))}>Dashboard</Button>
              <Button variant="outline" size="sm" data-testid="nav-logout-button" onClick={async () => { await logout(); navigate("/"); }}>Log out</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-login-button" onClick={() => navigate("/login")}>Log in</Button>
              <Button size="sm" data-testid="nav-get-started-button" onClick={() => (onGetService ? onGetService() : navigate("/register"))}>Get a Service</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
